import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import axios from 'axios';
import './FMSDashboard.css';
import AppSidebar from './AppSidebar';
import toast from 'react-hot-toast';
import { Toaster } from 'react-hot-toast';
// import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
// import Pagination from 'rc-pagination';
// import 'rc-pagination/assets/index.css';
import KanbanBoard from './KanbanBoard';



export function SidebarIcon({ type }) {
  const common = {
    width: 18,
    height: 18,
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    'aria-hidden': 'true'
  };

  switch (type) {
    case 'dashboard':
      return (
        <svg {...common}>
          <rect x="4" y="4" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
          <rect x="13" y="4" width="7" height="4" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
          <rect x="13" y="10" width="7" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
          <rect x="4" y="13" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
        </svg>
      );
    case 'tasks':
      return (
        <svg {...common}>
          <rect x="4" y="5" width="16" height="14" rx="2.5" stroke="currentColor" strokeWidth="1.8" />
          <path d="M8 9h8M8 13h8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <path d="M6.5 9l1 1 1.5-1.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'team':
      return (
        <svg {...common}>
          <circle cx="9" cy="8" r="3" stroke="currentColor" strokeWidth="1.8" />
          <circle cx="17" cy="9" r="2.5" stroke="currentColor" strokeWidth="1.8" />
          <path d="M3.5 19a5.5 5.5 0 0 1 11 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <path d="M13.5 19a4.5 4.5 0 0 1 7 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case 'reporting':
      return (
        <svg {...common}>
          <path d="M4 19h16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <path d="M6 16V10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <path d="M11 16V6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <path d="M16 16v-7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case 'settings':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
          <path
            d="M19.4 13a7.9 7.9 0 0 0 .1-2l2-1.2-2-3.4-2.2.7a8 8 0 0 0-1.7-1l-.3-2.3H10l-.3 2.3a8 8 0 0 0-1.7 1L5.8 6.4l-2 3.4L5.8 11a7.9 7.9 0 0 0 0 2l-2 1.2 2 3.4 2.2-.7a8 8 0 0 0 1.7 1l.3 2.3h5.2l.3-2.3a8 8 0 0 0 1.7-1l2.2.7 2-3.4z"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinejoin="round"
          />
        </svg>
      );
    default:
      return null;
  }
}

export function SupportIcon({ size = 20, color = 'currentColor', style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{ display: 'inline-block', marginRight: 8, verticalAlign: 'middle', ...(style || {}) }}
    >
      <path
        fillRule="evenodd"
        d="M0 10C0 4.478 4.478 0 10 0c5.523 0 10 4.478 10 10 0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10zm11.125 2.002H8.989v-.141c.01-1.966.492-2.254 1.374-2.782.093-.056.19-.114.293-.178.73-.459 1.292-1.038 1.292-1.883 0-.948-.743-1.564-1.666-1.564-.851 0-1.657.398-1.712 1.533H6.304C6.364 4.693 8.18 3.5 10.294 3.5c2.306 0 3.894 1.447 3.894 3.488 0 1.382-.695 2.288-1.805 2.952l-.238.144c-.79.475-1.009.607-1.02 1.777V12zm.17 3.012a1.344 1.344 0 01-1.327 1.328 1.32 1.32 0 01-1.328-1.328 1.318 1.318 0 011.328-1.316c.712 0 1.322.592 1.328 1.316z"
        fill={color}
      />
    </svg>
  );
}

export function LogoutIcon({ size = 16, style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{ display: 'inline-block', verticalAlign: 'middle', paddingLeft: 1, marginRight: 8, ...(style || {}) }}
    >
      <rect width="16" height="16" fill="none" />
      <path d="M14,14l0,-12l-6,0l0,-2l8,0l0,16l-8,0l0,-2l6,0Zm-9.002,-0.998l-4.998,-5.002l5,-5l1.416,1.416l-2.588,2.584l8.172,0l0,2l-8.172,0l2.586,2.586l-1.416,1.416Z" />
    </svg>
  );
}

function FmsIcon({ type, size = 18 }) {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    'aria-hidden': 'true'
  };

  switch (type) {
    case 'search':
      return <svg {...common}><circle cx="11" cy="11" r="6" stroke="currentColor" strokeWidth="2" /><path d="m16 16 4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>;
    case 'bell':
      return <svg {...common}><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M14 21h-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    case 'orders':
      return <svg {...common}><path d="M7 4h10l3 4v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8l3-4Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /><path d="M4 8h16M9 12h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>;
    case 'clock':
      return <svg {...common}><circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="1.8" /><path d="M12 8v4l3 2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    case 'box':
      return <svg {...common}><path d="m12 3 8 4-8 4-8-4 8-4Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /><path d="m4 7 8 4 8-4v10l-8 4-8-4V7Zm8 4v10" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /></svg>;
    case 'truck':
      return <svg {...common}><path d="M3 6h11v10H3V6Zm11 4h4l3 3v3h-7v-6Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /><circle cx="7" cy="18" r="2" stroke="currentColor" strokeWidth="1.8" /><circle cx="17" cy="18" r="2" stroke="currentColor" strokeWidth="1.8" /></svg>;
    case 'refresh':
      return <svg {...common}><path d="M20 11a8.1 8.1 0 0 0-14.9-3M4 4v4h4M4 13a8.1 8.1 0 0 0 14.9 3M20 20v-4h-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    case 'filter':
      return <svg {...common}><path d="M4 5h16M7 12h10M10 19h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>;
    case 'close':
      return <svg {...common}><path d="M18 6 6 18M6 6l12 12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>;
    case 'chevron-left':
      return <svg {...common}><path d="m15 18-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    case 'chevron-right':
      return <svg {...common}><path d="m9 18 6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    case 'check':
      return <svg {...common}><path d="m5 12 4 4L19 6" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    case 'warning':
      return <svg {...common}><path d="M12 3 2 21h20L12 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /><path d="M12 9v5M12 17h.01" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    default:
      return null;
  }
}

function formatDate(value) {
  if (!value || value === 'Pending') return 'Pending';
  const date = new Date(value);
  
  if (Number.isNaN(date.getTime())) return 'Pending';

  // This strips away the +05:30 and formats it cleanly for human eyes
  return date.toLocaleString('en-IN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true // Changes 14:15 to 02:15 PM
  });
}

const DATE_FILTER_OPTIONS = [
  { value: 'all', label: 'All dates' },
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last_7_days', label: 'Last 7 days' },
  { value: 'last_30_days', label: 'Last 30 days' },
  { value: 'this_month', label: 'This month' },
  { value: 'custom', label: 'Custom range' }
];

export function getLocalDateKey(date) {
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0')
  ].join('-');
}

function addDays(date, days) {
  const next = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  next.setDate(next.getDate() + days);
  return next;
}

function getOrderDateKey(value) {
  if (!value || value === 'Pending') return null;

  const textValue = String(value).trim();
  const dateMatch = textValue.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (dateMatch) return `${dateMatch[1]}-${dateMatch[2]}-${dateMatch[3]}`;

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;

  return getLocalDateKey(date);
}

function matchesDateFilter(orderDate, filterValue, customStartDate, customEndDate) {
  if (filterValue === 'all') return true;

  const orderDateKey = getOrderDateKey(orderDate);
  if (!orderDateKey) return false;

  if (filterValue === 'custom') {
    if (!customStartDate || !customEndDate) return false;
    return orderDateKey >= customStartDate && orderDateKey <= customEndDate;
  }

  const today = new Date();
  const todayKey = getLocalDateKey(today);

  if (filterValue === 'today') return orderDateKey === todayKey;
  if (filterValue === 'yesterday') return orderDateKey === getLocalDateKey(addDays(today, -1));
  if (filterValue === 'last_7_days') return orderDateKey >= getLocalDateKey(addDays(today, -6)) && orderDateKey <= todayKey;
  if (filterValue === 'last_30_days') return orderDateKey >= getLocalDateKey(addDays(today, -29)) && orderDateKey <= todayKey;
  if (filterValue === 'this_month') return orderDateKey.slice(0, 7) === todayKey.slice(0, 7);

  return true;
}

export function FmsDateRangePicker({ startDate, endDate, onDateChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const [viewDate, setViewDate] = useState(new Date());
  const [hoverDate, setHoverDate] = useState(null);
  const [step, setStep] = useState(startDate && !endDate ? 'end' : 'start');
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  

  const nextMonth = new Date(viewDate.getFullYear(), viewDate.getMonth() + 1, 1);
  const handlePrevMonth = () => setViewDate(new Date(viewDate.getFullYear(), viewDate.getMonth() - 1, 1));
  const handleNextMonth = () => setViewDate(new Date(viewDate.getFullYear(), viewDate.getMonth() + 1, 1));
  const getDaysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();
  const getFirstDayOfMonth = (year, month) => new Date(year, month, 1).getDay();

  const parseDateLocal = (value) => {
    if (!value) return null;
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day);
  };

  const formatDisplayDate = (value) => {
    if (!value) return 'MM/DD/YYYY';
    const [year, month, day] = value.split('-');
    return `${month}/${day}/${year}`;
  };

  const handleDayClick = (date) => {
    const dateString = getLocalDateKey(date);

    if (step === 'start') {
      onDateChange(dateString, '');
      setStep('end');
      return;
    }

    const start = parseDateLocal(startDate);
    if (start && date < start) {
      onDateChange(dateString, startDate);
    } else {
      onDateChange(startDate, dateString);
    }

    setStep('start');
    setIsOpen(false);
  };

  const renderCalendar = (year, month, position) => {
    const days = [];
    const daysInMonth = getDaysInMonth(year, month);
    const firstDay = getFirstDayOfMonth(year, month);

    for (let index = 0; index < firstDay; index++) days.push(null);
    for (let day = 1; day <= daysInMonth; day++) days.push(new Date(year, month, day));

    return (
      <div className="fms-calendar-pane">
        <div className="fms-calendar-header">
          {position === 'left' ? <button type="button" onClick={handlePrevMonth}>&lt;</button> : <div />}
          <span>{new Date(year, month).toLocaleString('default', { month: 'long', year: 'numeric' })}</span>
          {position === 'right' ? <button type="button" onClick={handleNextMonth}>&gt;</button> : <div />}
        </div>

        <div className="fms-calendar-grid">
          {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((dayName, index) => (
            <div key={`${dayName}-${index}`} className="fms-calendar-day-name">{dayName}</div>
          ))}
          {days.map((date, index) => {
            if (!date) return <div key={`empty-${index}`} className="fms-calendar-cell empty" />;

            const dateString = getLocalDateKey(date);
            const isStart = startDate === dateString;
            const isEnd = endDate === dateString;
            let inRange = false;

            if (startDate && endDate) {
              inRange = date > parseDateLocal(startDate) && date < parseDateLocal(endDate);
            } else if (startDate && hoverDate && step === 'end') {
              const start = parseDateLocal(startDate);
              inRange = start && ((date > start && date < hoverDate) || (date < start && date > hoverDate));
            }

            let classes = 'fms-calendar-cell';
            if (isStart) classes += ' range-start';
            if (isEnd) classes += ' range-end';
            if (inRange) classes += ' in-range';

            return (
              <button
                key={dateString}
                type="button"
                className={classes}
                onClick={() => handleDayClick(date)}
                onMouseEnter={() => setHoverDate(date)}
              >
                {date.getDate()}
              </button>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div className="fms-date-range-wrapper" ref={wrapperRef}>
      <button
        className={`fms-date-range-input ${isOpen ? 'active' : ''}`}
        type="button"
        onClick={() => setIsOpen((open) => !open)}
      >
        <span>{formatDisplayDate(startDate)} - {formatDisplayDate(endDate)}</span>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
      </button>

      {isOpen && (
        <div className="fms-date-range-popup">
          {renderCalendar(viewDate.getFullYear(), viewDate.getMonth(), 'left')}
          <div className="fms-calendar-divider" />
          {renderCalendar(nextMonth.getFullYear(), nextMonth.getMonth(), 'right')}
        </div>
      )}
    </div>
  );
}

function getStatusClass(status) {
  const value = String(status || '').toLowerCase();
  if (value.includes('cancelled') || value.includes('canceled')) return 'fms-status-red';
  if (value.includes('progress') || value.includes('processing')) return 'fms-status-blue';
  if (value.includes('dispatched')) return 'fms-status-violet';
  if (value.includes('packed') || value.includes('delivered') || value.includes('completed')) return 'fms-status-green';
  if (value.includes('invoice')) return 'fms-status-amber';
  return 'fms-status-slate';
}

const RIGHT_WORKFLOW_STEPS = [
  { key: 'order_received', label: 'Order Received', backendKey: null },
  { key: 'pre_invoice', label: 'Pre-Invoice', backendKey: 'pre_invoice' },
  { key: 'product_availability', label: 'Product Availability', backendKey: 'product_availability' },
  { key: 'dimensions_box', label: 'Dimensions Box', backendKey: 'dimensions_box' },
  { key: 'delivery_partner_assign', label: 'Partner Assigned', backendKey: 'delivery_partner_assign' },
  { key: 'post_invoice', label: 'Invoice Printed', backendKey: 'post_invoice' },
  { key: 'packaging_label', label: 'Packaging Label', backendKey: 'packaging_label' },
  { key: 'delivery_notes', label: 'Delivery Note', backendKey: 'delivery_notes' },
  { key: 'order_manifest', label: 'Order Manifest', backendKey: 'order_manifest' },
  { key: 'order_handover_for_preparation', label: 'Handover', backendKey: 'order_handover_for_preparation' },
  { key: 'k_sheet_entry', label: 'K-Sheet Entry', backendKey: 'k_sheet_entry' }, // Already manual
  { key: 'ready_to_dispatch', label: 'Ready to Dispatch', backendKey: 'ready_to_dispatch' }, // <-- REMOVED auto: true
  { key: 'handover_to_delivery_partner', label: 'Dispatched', backendKey: 'handover_to_delivery_partner' } // Already manual
];

const FMS_KANBAN_STEPS  = [
  { key: 'order_received', label: 'Order Received', backendKey: null },
  { key: 'pre_invoice', label: 'Pre-Invoice', backendKey: 'pre_invoice' },
  { key: 'product_availability', label: 'Product Availability', backendKey: 'product_availability' },
  { key: 'dimensions_box', label: 'Dimensions Box', backendKey: 'dimensions_box' },
  { key: 'delivery_partner_assign', label: 'Partner Assigned', backendKey: 'delivery_partner_assign' },
  { key: 'post_invoice', label: 'Invoice Printed', backendKey: 'post_invoice' },
  { key: 'packaging_label', label: 'Packaging Label', backendKey: 'packaging_label' },
  { key: 'delivery_notes', label: 'Delivery Note', backendKey: 'delivery_notes' },
  { key: 'order_manifest', label: 'Order Manifest', backendKey: 'order_manifest' },
  { key: 'order_handover_for_preparation', label: 'Handover', backendKey: 'order_handover_for_preparation' },
  { key: 'k_sheet_entry', label: 'K-Sheet Entry', backendKey: 'k_sheet_entry' }, // Already manual
  { key: 'ready_to_dispatch', label: 'Ready to Dispatch', backendKey: 'ready_to_dispatch' }, // <-- REMOVED auto: true
  { key: 'handover_to_delivery_partner', label: 'Dispatched', backendKey: 'handover_to_delivery_partner' }, // Already manual
  { key: 'cancelled', label: 'Cancelled', backendKey: null, terminal: true }
];

function buildFallbackWorkflowSteps(order) {
  return RIGHT_WORKFLOW_STEPS.map((step) => ({
    key: step.key,
    label: step.label,
    backendKey: step.backendKey,
    auto: step.auto || false,
    status: step.key === 'order_received' ? 'completed' : null,
    done: step.key === 'order_received',
    time: step.key === 'order_received' ? order?.order_date || null : null,
    actual_date: step.key === 'order_received' ? order?.order_date || null : null,
    planned_date: null,
    who: null,
    delay: null
  }));
}

// function matchesStatus(order, terms) {
//   const status = String(order.status || '').toLowerCase();
//   return terms.some((term) => status.includes(term));
// }

export function getInitials(user) {  
  const source = user?.emp_name || user?.username || 'User';
  return source
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');
}

export function getUserColor(userName) {
  if (!userName) return '#5b6ee1'; // fallback color
  
  // Create a hash of the user name
  let hash = 0;
  for (let i = 0; i < userName.length; i++) {
    hash = ((hash << 5) - hash) + userName.charCodeAt(i);
    hash = hash & hash; // Convert to 32bit integer
  }
  
  // Predefined palette of distinct colors
  const colors = [
    '#5b6ee1', // blue
    '#ec4899', // pink
    '#f97316', // orange
    '#06b6d4', // cyan
    '#8b5cf6', // purple
    '#10b981', // emerald
    '#f43f5e', // rose
    '#6366f1', // indigo
    '#14b8a6', // teal
    '#d97706', // amber
  ];
  
  return colors[Math.abs(hash) % colors.length];
}

// function SkeletonTableRow() {
//   return (
//     <tr className="fms-skeleton-row">
//       <td><Skeleton height={16} width="75px" /></td>
//       <td><Skeleton height={16} width="60px" /></td>
//       <td><Skeleton height={16} width="100px" /></td>
//       <td><Skeleton height={16} width="160px" /></td>
//       <td><Skeleton height={16} width="60px" /></td>
//       <td><Skeleton height={16} width="30px" /></td>
//       <td><Skeleton height={16} width="60px" /></td>
//       <td><Skeleton height={16} width="60px" /></td>
//       <td><Skeleton height={16} width="60px" /></td>
//     </tr>
//   );
// }

export default function FMSDashboard({
  user,
  onLogout,
  loggingOut,
  onNavigateToDashboard,
  onNavigateToTasks,
  onNavigateToFMS,
  onNavigateToReturns,
  onNavigateToDelegation,
  onNavigateToAllTasks,
  onNavigateToResourceControl,
  onNavigateToLogging
}) {

  const hasFMSDashboardAccess = () => {
    if (!user || !user.resource_access) {
      return false;
    }
    return user.resource_access.FMS_dashboard === true;
  };

    useEffect(() => {
         document.title = 'Order Processing FMS ';
       }, []);

  const hasAccess = user?.role === 1 || user?.role === 2;

  const accessGranted = hasFMSDashboardAccess();
  const [selectedOrderCode, setSelectedOrderCode] = useState(null);
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [syncLoading, setSyncLoading] = useState(false);
  const [syncMessage, setSyncMessage] = useState(null);
  const [syncError, setSyncError] = useState(null);
  const [stepLoadingKey, setStepLoadingKey] = useState(null);
  const [stepToUndo, setStepToUndo] = useState(null); // 👈 ADD THIS
  const [stepMessage, setStepMessage] = useState(null);
  const [stepError, setStepError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [channelFilter, setChannelFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [dateFilter, setDateFilter] = useState('all');
  const [customStartDate, setCustomStartDate] = useState(() => getLocalDateKey(new Date()));
  const [customEndDate, setCustomEndDate] = useState(() => getLocalDateKey(new Date()));
  const [refreshLoading, setRefreshLoading] = useState(false); // Track which order is being refreshed
  // const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = 7;


  

  const fetchOrders = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await axios.get('/api/fms-orders');
      if (response.data.success) {
        setOrders(Array.isArray(response.data.data) ? response.data.data : []);
      } else {
        setOrders([]);
      }
    } catch (error) {
      console.error('Failed to fetch orders:', error);
      setOrders([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  useEffect(() => {
    // setCurrentPage(1);
  }, [searchTerm, channelFilter, statusFilter, dateFilter, customStartDate, customEndDate]);

  const handleSyncOrders = async () => {
    setSyncLoading(true);
    setSyncMessage(null);
    setSyncError(null);

    try {
      const response = await fetch('/api/insert-fms-orders', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();

      if (data.success && (user?.role === 1 || user?.role === 2)) {
        toast.success(`Sync completed. Inserted: ${data.inserted}, skipped: ${data.skipped}.`);
        await fetchOrders();
      } else if (data.success) {
        toast.success('Sync completed successfully.');
        // await fetchOrders();
      } else {
        toast.error(data.message || 'Sync failed');
      }
    } catch (error) {
      setSyncError('Error syncing orders: ' + error.message);
    } finally {
      setSyncLoading(false);
    }
  };

  const activeOrder = orders.find((order) => order.order_code === selectedOrderCode);

  const workflowSteps = useMemo(() => {
    if (!activeOrder) return [];
    if (Array.isArray(activeOrder.workflow_steps) && activeOrder.workflow_steps.length > 0) {
      return activeOrder.workflow_steps;
    }
    return buildFallbackWorkflowSteps(activeOrder);
  }, [activeOrder]);

  const completedCount = workflowSteps.filter((step) => step.done || step.status === 'completed').length;
  const progressPercentage = workflowSteps.length ? Math.round((completedCount / workflowSteps.length) * 100) : 0;

  const channels = useMemo(() => {
    return [...new Set(orders.map((order) => order.channel).filter(Boolean))].sort();
  }, [orders]);

  const statuses = useMemo(() => {
    return [...new Set(orders.map((order) => order.status).filter(Boolean))].sort();
  }, [orders]);

  const filteredOrders = useMemo(() => {
    const normalizedSearch = searchTerm.trim().toLowerCase();

    return orders.filter((order) => {
      const searchableText = [
        order.order_code,
        order.order_id,
        order.product_name,
        order.channel,
        order.status
      ].join(' ').toLowerCase();

      const matchesSearch = !normalizedSearch || searchableText.includes(normalizedSearch);
      const matchesChannel = channelFilter === 'all' || order.channel === channelFilter;
      const matchesSelectedStatus = statusFilter === 'all' || order.status === statusFilter;
      const matchesSelectedDate = matchesDateFilter(order.order_date, dateFilter, customStartDate, customEndDate);

      return matchesSearch && matchesChannel && matchesSelectedStatus && matchesSelectedDate;
    });
  }, [channelFilter, customEndDate, customStartDate, dateFilter, orders, searchTerm, statusFilter]);

  useEffect(() => {
    if (!selectedOrderCode) return;
    if (!filteredOrders.some((order) => order.order_code === selectedOrderCode)) {
      setSelectedOrderCode(null);
    }
  }, [filteredOrders, selectedOrderCode]);

 const summaryCards = useMemo(() => {
  let inProgressCount = 0;
  let packedCount = 0;
  let dispatchedCount = 0;

  const packedStages = new Set(['packaging_label', 'delivery_notes', 'order_manifest', 'order_handover_for_preparation', 'k_sheet_entry', 'ready_to_dispatch']);
  const dispatchedStage = 'handover_to_delivery_partner';

  // 👇 CHANGED: Loop over filteredOrders instead of orders
  filteredOrders.forEach((order) => {
    const steps = Array.isArray(order.workflow_steps) ? order.workflow_steps : [];

    // Same idea as KanbanBoard: find the latest consecutive completed stage
    let currentStageKey = 'order_received';

    for (let i = 0; i < RIGHT_WORKFLOW_STEPS.length; i++) {
      const stageDef = RIGHT_WORKFLOW_STEPS[i];
      const step = steps.find((s) => s.key === stageDef.key);
      const isCompleted = Boolean(
        step?.done ||
        step?.status === 'completed' ||
        step?.actual_date
      );

      if (isCompleted) {
        currentStageKey = stageDef.key;
      } else {
        break;
      }
    }

    if (currentStageKey === dispatchedStage) {
      dispatchedCount++;
    } else if (packedStages.has(currentStageKey)) {
      packedCount++;
    } else if (currentStageKey !== 'order_received') {
      inProgressCount++;
    }
  });

  return [
    {
      label: 'Total Returns',
      // 👇 CHANGED: Use filteredOrders.length instead of orders.length
      value: accessGranted ? filteredOrders.length : "-",
      note: 'Orders in the current queue',
      icon: 'box',
      tone: 'indigo'
    },
    {
      label: 'In Progress',
      value: accessGranted ? inProgressCount : "-",
      note: 'Before handover',
      icon: 'clock',
      tone: 'blue'
    },
    {
      label: 'Packed',
      value: accessGranted ? packedCount : "-",
      note: 'Ready To Dispatch',
      icon: 'box',
      tone: 'amber'
    },
    {
      label: 'Completed',
      value: accessGranted ? dispatchedCount : "-",
      note: 'Handed over to delivery partner',
      icon: 'check',
      tone: 'emerald'
    }
  ];
// 👇 CHANGED: Added filteredOrders and accessGranted to the dependency array
}, [filteredOrders, accessGranted]);

  // const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);
  // const indexOfLastOrder = currentPage * itemsPerPage;
  // const indexOfFirstOrder = indexOfLastOrder - itemsPerPage;
  // const currentOrders = filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);

  const handleMarkRightStepDone = async (step, explicitOrderCode = null) => {
    // FIX: Look for explicitOrderCode first (from Kanban), fallback to activeOrder (from Sidebar)
    const targetOrderCode = explicitOrderCode || activeOrder?.order_code;

    if (!targetOrderCode || !step?.backendKey || step.done) return;

    setStepLoadingKey(step.key);
    setStepMessage(null);
    setStepError(null);

    try {
      const response = await fetch('/api/update-fms-step', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          orderCode: targetOrderCode, // Uses the right target code
          stepName: step.backendKey,
          who: null
        })
      });

      const result = await response.json();

      if (result.success) {
        setStepMessage(`${step.label} marked as completed.`);
        await fetchOrders(); // Refreshes JSON from backend, automatically moving card
        setTimeout(() => setStepMessage(null), 2500);
      } else {
        setStepError(result.message || 'Failed to update step');
      }
    } catch (error) {
      setStepError('Failed to update step: ' + error.message);
    } finally {
      setStepLoadingKey(null);
    }
  };

  const handleUndoRightStep = async () => {
  if (!stepToUndo || !activeOrder) return;
  const targetOrderCode = activeOrder.order_code;
  const step = stepToUndo;
  
  setStepLoadingKey(step.key);
  setStepToUndo(null);
  setStepMessage(null);
  setStepError(null);

  try {
    const response = await fetch('/api/undo-fms-step', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        orderCode: targetOrderCode,
        stepName: step.backendKey
      })
    });

    const data = await response.json();

    if (!response.ok) throw new Error(data.message);

    toast(`✓ Step "${step.label}" has been undone`);
    await fetchOrders();
  } catch (error) {
    setStepError(`Failed to undo step: ${error.message}`);
  } finally {
    setStepLoadingKey(null);
  }
};

  const ordersRef = useRef([]);
const refreshInProgressRef = useRef(false);

useEffect(() => {
  ordersRef.current = orders;
}, [orders]);

const isDispatchedOrder = (order) => {
  const status = String(order?.status || '').toLowerCase();
  if (status.includes('dispatched')) return true;

  const steps = Array.isArray(order?.workflow_steps) ? order.workflow_steps : [];
  if (!steps.length) return false;

  const dispatchIndex = RIGHT_WORKFLOW_STEPS.length - 1;

  let currentStageIndex = 0;
  for (let i = steps.length - 1; i >= 0; i--) {
    const step = steps[i];
    if (step?.done || step?.status === 'completed' || step?.actual_date) {
      currentStageIndex = i;
      break;
    }
  }

  return currentStageIndex >= dispatchIndex;
};

const handleRefreshOrderFromUnicommerce = useCallback(async (orderCodeToRefresh) => {
  try {
    if (!orderCodeToRefresh) return null;

    const response = await fetch('/api/update-order-from-unicommerce', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orderCode: orderCodeToRefresh })
    });

    const result = await response.json();

    if (result.success) {
      return {
        orderCode: orderCodeToRefresh,
        workflow_steps: result.workflow_steps
      };
    }

    throw new Error(result.message || `Failed to refresh order ${orderCodeToRefresh}`);
  } catch (error) {
    console.error('Refresh order error:', error);
    return null;
  }
}, []);

const handleOrderClick = (orderCode) => {
  setSelectedOrderCode(orderCode);
};

const refreshPendingOrdersFromUnicommerce = useCallback(async () => {
  if (refreshInProgressRef.current) return;

  const pendingOrders = (ordersRef.current || []).filter((order) => !isDispatchedOrder(order));
  if (!pendingOrders.length) return;

  refreshInProgressRef.current = true;
  setRefreshLoading(true);

  try {
    const refreshedResults = await Promise.all(
      pendingOrders.map((order) => handleRefreshOrderFromUnicommerce(order.order_code))
    );

    const refreshedMap = new Map(
      refreshedResults
        .filter(Boolean)
        .map((item) => [item.orderCode, item.workflow_steps])
    );

    if (refreshedMap.size > 0) {
      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          refreshedMap.has(order.order_code)
            ? { ...order, workflow_steps: refreshedMap.get(order.order_code) }
            : order
        )
      );
    }
  } finally {
    refreshInProgressRef.current = false;
    setRefreshLoading(false);
  }
}, [handleRefreshOrderFromUnicommerce]);

useEffect(() => {
  refreshPendingOrdersFromUnicommerce();

  const intervalId = setInterval(() => {
    refreshPendingOrdersFromUnicommerce();
  }, 10000);

  return () => clearInterval(intervalId);
}, [refreshPendingOrdersFromUnicommerce]);


  return (
    <div className="fms-shell">
       <Toaster position="top-right" />
      <AppSidebar
        user={user}
        active="fms"
        onLogout={onLogout}
        loggingOut={loggingOut}
        onNavigateToDashboard={onNavigateToDashboard}
        onNavigateToTasks={onNavigateToTasks}
        onNavigateToFMS={onNavigateToFMS}
        onNavigateToReturns={onNavigateToReturns}
        onNavigateToDelegation={onNavigateToDelegation}
        onNavigateToAllTasks={onNavigateToAllTasks}
        onNavigateToResourceControl={onNavigateToResourceControl}
        onNavigateToLogging={onNavigateToLogging}
      />

      <main className="fms-main">
        <header className="fms-topbar rrl-topbar">
                  <div className="mobile-left">
                    <button className="mobile-menu-btn" type="button" aria-label="Open menu" />
                  </div>
        
                  {/* <div className="fms-global-search">
                    <input 
                      type="search" 
                      placeholder="Search orders, customers, or products..." 
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div> */}
        
                   <div className="topbar-actions">
                    {/* <button className="icon-btn icon-view desktop-view-trigger" type="button" aria-label="View options" />
                    <button className="icon-btn icon-view mobile-nav-trigger" type="button" aria-label="Open navigation" /> */}
                    <div className="avatar-placeholder" style={{ background: getUserColor(user?.emp_name || user?.username) }}>
                      {getInitials(user)}
                    </div>
                  </div>
                </header>

        <div className="fms-content">
          <div className="fms-page">
            <section className="fms-hero">
              <div className="fms-hero-heading">
                <span className="fms-eyebrow">Live operations</span>
                <h1>FMS Order Dashboard</h1>
                <p>Track fulfillment activity from order receipt through final dispatch.</p>
              </div>
            {accessGranted && (
              <div className="fms-hero-actions">
                <label className="fms-filter-control">
                  <span>Channel</span>
                  <select value={channelFilter} onChange={(event) => setChannelFilter(event.target.value)}>
                    <option value="all">All channels</option>
                    {channels.map((channel) => <option key={channel} value={channel}>{channel}</option>)}
                  </select>
                </label>
                <label className="fms-filter-control">
                  <span>Status</span>
                  <select value={statusFilter} onChange={(event) => setStatusFilter(event.target.value)}>
                    <option value="all">All statuses</option>
                    {statuses.map((status) => <option key={status} value={status}>{status}</option>)}
                  </select>
                </label>
                <label className="fms-filter-control">
                  <span>Date</span>
                  <select value={dateFilter} onChange={(event) => setDateFilter(event.target.value)}>
                    {DATE_FILTER_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                  </select>
                </label>
                {dateFilter === 'custom' && (
                  <div className="fms-filter-control fms-date-range-control">
                    <span>Range</span>
                    <FmsDateRangePicker
                      startDate={customStartDate}
                      endDate={customEndDate}
                      onDateChange={(start, end) => {
                        setCustomStartDate(start);
                        setCustomEndDate(end);
                      }}
                    />
                  </div>
                )}
                <button className="fms-secondary-button" onClick={() => {
                  setSearchTerm('');
                  setChannelFilter('all');
                  setStatusFilter('all');
                  setDateFilter('all');
                  setCustomStartDate(getLocalDateKey(new Date()));
                  setCustomEndDate(getLocalDateKey(new Date()));
                }}>
                  <FmsIcon type="filter" size={16} />
                  Clear filters
                </button>
                {accessGranted && (
                  <button className="fms-primary-button" onClick={handleSyncOrders} disabled={syncLoading}>
                    <FmsIcon type="refresh" size={16} />
                    {syncLoading ? 'Syncing...' : 'Sync orders'}
                  </button>
                )}
              </div>)}
            </section>

            {(syncMessage || syncError) && (
              <div className={`fms-alert ${syncMessage ? 'fms-alert-success' : 'fms-alert-error'}`}>
                {syncMessage || syncError}
              </div>
            )}

            <section className="fms-summary-grid">
              {summaryCards.map((card) => (
                <StatCard key={card.label} {...card} isLoading={isLoading} />
              ))}
            </section>

            <section className={`fms-workspace ${activeOrder ? 'fms-workspace-with-details' : ''}`}>
              

<div className="fms-workspace-with-details">
  <div className="fms-orders-card">
    <div className="fms-card-header">
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: '16px' }}>
    <div>
      <span className="fms-eyebrow">FMS WORKFLOW</span>
      <h2>Order Pipeline</h2>
    </div>
    <input
      type="text"
      placeholder="Search by Order ID..."
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      style={{
        padding: '10px 16px',
        borderRadius: '6px',
        border: '1px solid #e4eaf2',
        fontSize: '14px',
        width: '250px',
        boxSizing: 'border-box',
        transition: 'border-color 0.2s ease',
        marginLeft: 'auto'
      }}
      onFocus={(e) => e.target.style.borderColor = '#1f5f55'}
      onBlur={(e) => e.target.style.borderColor = '#e4eaf2'}
    />
  </div>
</div>

    {/* Kanban View */}
    {accessGranted ? (
  <KanbanBoard
    orders={filteredOrders}
    workflowSteps={FMS_KANBAN_STEPS}
    activeOrderCode={selectedOrderCode}
    onOrderClick={setSelectedOrderCode}
    onMarkStepDone={handleMarkRightStepDone}
    stepLoadingKey={stepLoadingKey}
    syncLoading={isLoading || syncLoading}
  />
) : (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100%',
    flexDirection: 'column',
    gap: '16px',
    textAlign: 'center',
    padding: '40px 20px'
  }}>
    <div style={{
      background: '#fef3c7',
      border: '1px solid #fcd34d',
      borderRadius: '8px',
      padding: '32px 40px',
      maxWidth: '500px'
    }}>
      <h2 style={{
        margin: '0 0 12px 0',
        fontSize: '20px',
        fontWeight: '700',
        color: '#92400e'
      }}>
        🔒 Access Denied
      </h2>
      <p style={{
        margin: '0 0 20px 0',
        fontSize: '14px',
        color: '#b45309',
        lineHeight: '1.6'
      }}>
        You don't have access to the FMS Dashboard. Please contact your administrator to request access.
      </p>
      <button
        type="button"
        onClick={onNavigateToTasks}
        style={{
          background: '#1f5f55',
          color: 'white',
          border: 'none',
          padding: '10px 24px',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: '600',
          transition: 'background 0.2s ease'
        }}
        onMouseEnter={(e) => e.target.style.background = '#184743'}
        onMouseLeave={(e) => e.target.style.background = '#1f5f55'}
      >
        ← Back to checklist
      </button>
    </div>
  </div>
)}
  </div>

  
</div>
{/* Right Sidebar - Order Details */}
{/* 👇 NEW UNDO CONFIRMATION MODAL 👇 */}
{/* 👇 UNDO CONFIRMATION MODAL 👇 */}
{stepToUndo && (
  <div className="confirmation-modal-overlay">
    <div className="confirmation-modal">
      <h3>Undo Step</h3>
      <p>Are you sure you want to undo <strong>{stepToUndo.label}</strong>? This will also reset any steps completed after it.</p>
      <div className="confirmation-modal-actions">
        <button className="confirmation-btn cancel" onClick={() => setStepToUndo(null)}>Cancel</button>
        <button className="confirmation-btn confirm" style={{ backgroundColor: '#e11d48' }} onClick={handleUndoRightStep}>Undo Step</button>
      </div>
    </div>
  </div>
)}
{/* 👆 UNDO CONFIRMATION MODAL 👆 */}

{/* Right Sidebar - Order Details */}
{activeOrder && (
  <OrderDetailsPanel
    activeOrder={activeOrder}
    completedCount={completedCount}
    progressPercentage={progressPercentage}
    workflowSteps={workflowSteps}
    stepLoadingKey={stepLoadingKey}
    stepMessage={stepMessage}
    stepError={stepError}
    onClose={() => setSelectedOrderCode(null)}
    onMarkDone={handleMarkRightStepDone}
    onUndoStep={setStepToUndo} // 👈 THIS IS CRITICAL FOR THE POPUP TO SHOW
  />
)}
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}

function StatCard({icon, isLoading, label, note, tone, value  }) {
  return (
    <article className={`fms-stat-card style-${tone}`}>
      <div className="fms-stat-icon-box">
        <FmsIcon type={icon} size={18} />
      </div>
      <div>
        <p>{label}</p>
        <strong>{isLoading ? '-' : value}</strong>
        {note ? <span>{note}</span> : null}
      </div>
    </article>
  );
}

// function TableRow({ order, active, onClick }) {
//   return (
//     <tr onClick={onClick} className={active ? 'fms-row-active' : ''}>
//       <td data-label="Order code"><strong className="fms-order-code">{order.order_code}</strong></td>
//       <td data-label="Order date">{formatDate(order.order_date)}</td>
//       <td data-label="Order ID"><span className="fms-muted-value">{order.order_id}</span></td>
//       <td data-label="Product"><span className="fms-product-name" title={order.product_name}>{order.product_name}</span></td>
//       <td data-label="Channel"><span className="fms-channel-badge">{order.channel}</span></td>
//       <td data-label="Quantity">{order.quantity}</td>
//       <td data-label="Status"><span className={`fms-status-badge ${getStatusClass(order.status)}`}>{order.status}</span></td>
//       <td data-label="Invoice date">{formatDate(order.invoice_date)}</td>
//       <td data-label="Dispatched">{formatDate(order.dispatched_date)}</td>
//     </tr>
//   );
// }
// 👇 NEW DELAY CHECKER 👇
function checkIfDelayed(step) {
  if (!step) return false;
  // 1. If backend previously flagged it as delayed
  if (step.delay > 0) return true; 
  // 2. If it's already done (and didn't have a delay), it's safe
  if (step.done || step.status === 'completed') return false; 

  // 3. If it's currently pending, check the exact planned time
  if (step.planned_date) {
    let dateString = step.planned_date;
    if (typeof dateString === 'string') {
      dateString = dateString.replace(' ', 'T');
      if (!dateString.includes('Z') && !dateString.includes('+')) {
        dateString += '+05:30';
      }
    }
    const plannedTimestamp = new Date(dateString).getTime();
    return !isNaN(plannedTimestamp) && Date.now() > plannedTimestamp;
  }
  
  return false;
}

// 👇 NEW OVERALL DELAY CHECKER 👇
function getSafeTimestamp(dateString) {
  if (!dateString) return NaN;
  let safeStr = dateString;
  if (typeof safeStr === 'string') {
    safeStr = safeStr.replace(' ', 'T');
    if (!safeStr.includes('Z') && !safeStr.includes('+')) {
      safeStr += '+05:30';
    }
  }
  return new Date(safeStr).getTime();
}

// 👇 ASSIGNED PERSON HELPER 👇
function getAssignedPerson(workflowSteps) {
  if (!Array.isArray(workflowSteps) || workflowSteps.length === 0) return 'Unassigned';
  
  // Find the current stage index (furthest completed step)
  let currentStageIndex = 0;
  for (let i = workflowSteps.length - 1; i >= 0; i--) {
    const step = workflowSteps[i];
    if (step.done || step.status === 'completed' || step.actual_date) {
      currentStageIndex = i;
      break;
    }
  }
  
  // Assign based on stage:
  // Steps 0-9 (up to and including handover): Asif
  // Step 10 (delivery_notes): Asif
  // Step 11 (dispatched): Asif
  if (currentStageIndex <= 9) {
    return 'Asif';
  } else if (currentStageIndex === 10) {
    return 'Asif';
  } else {
    return 'Asif';
  }
}
// 👆 ASSIGNED PERSON HELPER 👆


// 👇 UPDATED OVERALL DELAY CHECKER 👇
function isOrderOverallDelayed(activeOrder, workflowSteps) {
  // 1. Read directly from the new database column if available
  // (Handles both boolean true/false and MySQL TINYINT 1/0)
  if (activeOrder && typeof activeOrder.delayed_task !== 'undefined') {
    return Boolean(activeOrder.delayed_task);
  }

  // 2. Fallback UI Calculation (Targets 11:01 AM and order_manifest)
  const orderTimestamp = getSafeTimestamp(activeOrder?.order_date);
  if (isNaN(orderTimestamp)) return false;

  const orderDateObj = new Date(orderTimestamp);

  // Set to NEXT day
  let targetDay = new Date(orderDateObj.getFullYear(), orderDateObj.getMonth(), orderDateObj.getDate() + 1);
  
  // Skip Sunday (0)
  if (targetDay.getDay() === 0) { 
    targetDay.setDate(targetDay.getDate() + 1);
  }
  
  // Lock exactly to 11:01 AM
  targetDay.setHours(11, 1, 0, 0);
  const masterDeadline = targetDay.getTime();

  // Find specifically the order_manifest step
  const manifestStep = workflowSteps.find(step => step.key === 'order_manifest');

  // If manifest is completed, check if it was done late
  if (manifestStep && (manifestStep.done || manifestStep.status === 'completed')) {
    const completionTime = getSafeTimestamp(manifestStep.actual_date);
    return !isNaN(completionTime) && completionTime > masterDeadline;
  }

  // If manifest is NOT done, is the current exact time past 11:01 AM?
  return Date.now() > masterDeadline;
}
// 👆 NEW OVERALL DELAY CHECKER 👆
// 👆 NEW DELAY CHECKER 👆
function OrderDetailsPanel({
  activeOrder,
  completedCount,
  onClose,
  onMarkDone,
  onUndoStep, // 👈 Must receive the prop here
  progressPercentage,
  stepError,
  stepLoadingKey,
  stepMessage,
  workflowSteps
}) {
  // Check if the overall order is delayed
 // Check if the overall order is delayed
  const isOverallDelayed = isOrderOverallDelayed(activeOrder, workflowSteps);

  return (
    <aside className="fms-details-panel">
      <div className="fms-details-header">
        <div>
          <span className="fms-section-label">Selected order</span>
        </div>
        <button onClick={onClose} aria-label="Close details">
          <FmsIcon type="close" size={16} />
        </button>
      </div>

      <div className="fms-details-body">
        <div className="fms-order-overview">
          <div className="fms-order-overview-top">
            <div>
              <span>Order code</span>
              <h3>{activeOrder.order_id}</h3>
            </div>
            
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              {isOverallDelayed && (
                <span className="fms-status-badge" style={{ backgroundColor: '#fff4f5', color: '#b42335', borderColor: '#fac7cc' }}>
                  ⚠ Delayed
                </span>
              )}
              <span className={`fms-status-badge ${getStatusClass(activeOrder.status)}`}>{activeOrder.status}</span>
            </div>
          </div>
          <p>{activeOrder.product_name}</p>

          <div className="fms-order-facts">
            <div>
              <span>Channel</span>
              <strong>{activeOrder.channel}</strong>
            </div>
            <div>
              <span>Received</span>
              <strong>{formatDate(activeOrder.order_date)}</strong>
            </div>
            <div>
              <span>Assigned to</span>
              <strong>{getAssignedPerson(workflowSteps)}</strong>
            </div>
          </div>
        </div>

        <div className="fms-progress-block">
          <div>
            <span>Fulfillment progress</span>
            <strong>{progressPercentage}%</strong>
          </div>
          <div className="fms-progress-track">
            <span style={{ width: `${progressPercentage}%` }} />
          </div>
          <p>{completedCount} of {workflowSteps.length} steps completed</p>
        </div>

        {(stepMessage || stepError) && (
          <div className={`fms-alert ${stepMessage ? 'fms-alert-success' : 'fms-alert-error'}`}>
            {stepMessage || stepError}
          </div>
        )}

        <div className="fms-timeline-heading">
          <h3>Process timeline</h3>
          <span>Update each completed action</span>
        </div>

        <div className="fms-timeline">
          {workflowSteps.map((step) => {
            const isStepDelayed = checkIfDelayed(step);
            
            return (
              <RightProcessStep
                key={step.key}
                title={step.label}
                time={step.time || step.actual_date || step.planned_date || null}
                done={Boolean(step.done || step.status === 'completed')}
                canMark={Boolean(step.backendKey)}
                busy={stepLoadingKey === step.key}
                onMarkDone={() => onMarkDone(step)}
                onUndoStep={() => onUndoStep(step)} // 👈 Passes the popup trigger down
                isDelayed={isStepDelayed}
              />
            );
          })}
        </div>
      </div>
    </aside>
  );
}

function RightProcessStep({ busy, canMark, done, onMarkDone, onUndoStep, time, title, isDelayed }) {
  return (
    <div className={`fms-timeline-step ${done ? 'is-done' : ''}`}>
      <div className="fms-timeline-marker">
        {done ? <FmsIcon type="check" size={13} /> : <span />}
      </div>
      <div className="fms-timeline-card">
        <div style={{ display: 'grid', gap: '4px' }}>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <strong>{title}</strong>
            {isDelayed && (
              <span style={{ fontSize: '10px', color: '#f43f5e', fontWeight: 800 }}>⚠ Delayed</span>
            )}
          </div>

          <span>{time && time !== 'Pending' ? formatDate(time) : 'Awaiting completion'}</span>
        </div>
        {canMark ? (
          <button 
            onClick={done ? onUndoStep : onMarkDone} // 👈 If done, clicking triggers the popup
            disabled={busy} // 👈 Button is NO LONGER permanently disabled when done
            style={done ? { backgroundColor: '#fff1f2', borderColor: '#fda4af', color: '#e11d48' } : {}}
          >
            {busy ? 'Saving...' : (done ? 'Undo' : 'Mark done')}
          </button>
        ) : (
          <span className="fms-auto-badge">Auto</span>
        )}
      </div>
    </div>
  );
}
